/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyMaintenanceTask,
    ReadOnlyMaintenanceTaskFromJSON,
    ReadOnlyMaintenanceTaskFromJSONTyped,
    ReadOnlyMaintenanceTaskToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20017
 */
export interface InlineResponse20017 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20017
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20017
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20017
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyMaintenanceTask>}
     * @memberof InlineResponse20017
     */
    results: Array<ReadOnlyMaintenanceTask>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20017
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20017
     */
    limit?: number;
}

export function InlineResponse20017FromJSON(json: any): InlineResponse20017 {
    return InlineResponse20017FromJSONTyped(json, false);
}

export function InlineResponse20017FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20017 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyMaintenanceTaskFromJSON)),
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function InlineResponse20017ToJSON(value?: InlineResponse20017 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyMaintenanceTaskToJSON)),
        'offset': value.offset,
        'limit': value.limit,
    };
}


